import { render, staticRenderFns } from "./GrachioDisplay.vue?vue&type=template&id=57305800&scoped=true&"
import script from "./GrachioDisplay.vue?vue&type=script&lang=js&"
export * from "./GrachioDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GrachioDisplay.vue?vue&type=style&index=0&id=57305800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57305800",
  null
  
)

component.options.__file = "GrachioDisplay.vue"
export default component.exports